export const MyTablePageStyle = {
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    minHeight: 'calc(100vh - 152px)',
    maxHeight: 'fit-content',
    boxShadow: 'var(--box-shadow--2)',

    '@media (min-width: 1200px)': {
      minHeight: 'calc(100vh - 128px)',
      maxHeight: 'fit-content',
    },

    '& > .MuiBox-root': {
      height: '100%',
    },
  },

  loader: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
};
